import React from 'react';
import { PulseLoader } from 'react-spinners';
import { LineCharContainerLoading } from './styles';

export interface LoadingLineChartProps {
  height?: string;
}

export function LoadingLineChart({ ...props }: LoadingLineChartProps) {
  return (
    <LineCharContainerLoading {...props}>
      <PulseLoader color="var(--blue-100)" />
    </LineCharContainerLoading>
  );
}
